import { twMerge } from 'tailwind-merge'

const variants = {
  primary:
    'before:left-1/2 before:-translate-x-1/2 md:before:left-0 md:before:translate-x-0',
  secondary: 'before:left-0',
  tertiary: 'before:left-1/2 before:-translate-x-1/2 ',
}
type SectionTitleProps = {
  title: string
  variant?: keyof typeof variants
  className?: string
}

export const SectionTitle = ({
  title,
  variant = 'primary',
  className,
}: SectionTitleProps) => {
  return (
    <span
      className={twMerge(
        "relative w-fit text-[24px] [font-weight:700] font-[nunito] leading-[28.8px] text-[#D4AF37] before:absolute before:bottom-0  before:w-1/2  before:border-b-2 before:border-[#8C1D40] before:content-[''] md:text-[36px] md:leading-[43.2px] lg:text-[48px] lg:leading-[57.6px]",
        variants[variant],
        className
      )}
    >
      {title}
    </span>
  )
}
